// src/data/handyman-services.ts
export const handymanServiceCategories = {
  "Home Repairs & Maintenance": [
    "Electrician",
    "Plumber",
    "Carpenter",
    "Welder",
    "Painter",
    "Tiler",
    "Bricklayer",
    "POP Installer",
    "Flooring Specialist",
    "Glazier (Glass Installer)",
    "Ceiling Installer",
    "Roof Repair Specialist",
    "Water Tank Installer",
    "Generator Technician",
  ],
  "Appliance & Device Repair": [
    "AC Technician",
    "Refrigerator Repair",
    "Washing Machine Repair",
    "Microwave Repair",
    "TV Technician",
    "Phone Repair",
    "Laptop Repair",
    "Inverter Technician",
    "Solar Panel Installer",
    "CCTV Installer",
    "Home Automation Expert",
  ],
  "Transportation & Mobility": [
    "Driver",
    "Mechanic",
    "Motorcycle Mechanic",
    "Panel Beater",
    "Vehicle Electrician",
    "Tire Technician",
    "Tow Truck Operator",
    "Delivery Agent",
    "Dispatch Rider",
    "Boat Mechanic",
  ],
  "Furniture & Interior": [
    "Furniture Maker",
    "Cabinet Installer",
    "Interior Designer",
    "Upholsterer",
    "Curtain & Blinds Installer",
    "Wallpaper Installer",
    "Furniture Repair Specialist",
  ],
  "Construction & Building": [
    "Site Labourer",
    "Mason",
    "Scaffolder",
    "Steel Fixer",
    "Surveyor Assistant",
    "Borehole Driller",
    "Construction Equipment Operator",
    "Brick Mold Technician",
  ],
  "Cleaning & Sanitation": [
    "House Cleaner",
    "Office Cleaner",
    "Janitor",
    "Fumigator/Pest Control",
    "Waste Collector",
    "Sewage Tank Evacuation",
    "Car Wash Attendant",
    "Gutter Cleaner",
  ],
  "Beauty & Personal Services": [
    "Barber",
    "Hairdresser",
    "Makeup Artist",
    "Manicurist",
    "Pedicurist",
    "Spa Therapist",
    "Tailor",
    "Fashion Designer",
    "Skincare Consultant",
    "Massage Therapist",
  ],
  "Event & Hospitality Services": [
    "Cook",
    "Caterer",
    "Waiter/Server",
    "Event Decorator",
    "DJ",
    "MC/Compere",
    "Bouncer/Security Guard",
    "Photographer",
    "Videographer",
    "Event Cleaner",
  ],
  "Tech & IT Support": [
    "CCTV Installer",
    "Satellite Dish Installer",
    "Network Technician",
    "IT Support Technician",
    "POS Repair Technician",
    "Printer Repair",
    "Web Cafe Operator",
  ],
  "Domestic & Lifestyle": [
    "Nanny",
    "Housekeeper",
    "Laundry Service",
    "Dry Cleaner",
    "Gardener",
    "Dog Walker",
    "Pet Groomer",
    "Errand Runner",
    "Security Guard",
    "Carer",
    "Personal Assistant",
    "Household Manager",
    "Babysitter",
    "Personal Shopper",
    "Personal Driver",
    "Personal Chef",
    "Personal Trainer",
    "Personal Organizer",
  ],
  "Business & Office Support": [
    "Office Assistant",
    "Photocopy & Typing Operator",
    "Messenger",
    "Office Cleaner",
    "Maintenance Technician",
    "Facility Manager",
  ],
  "Other Specialized Trades": [
    "Goldsmith",
    "Shoemaker/Cobbler",
    "Watch Repairer",
    "Blacksmith",
    "Tiler (Marble/Granite)",
    "Aluminium Fabricator",
    "Iron Bender",
    "Water Treatment Specialist",
  ],
} as const;

export type HandymanCategory = keyof typeof handymanServiceCategories;
export type HandymanService =
  typeof handymanServiceCategories[HandymanCategory][number];
// Ensures the file is a module
export {};
